import React, { Component } from "react";
import { LocalStorageService } from "../../../services";
import { DigitalContractReportView } from "../../views";

class DigitalContractReportAction extends Component {
    constructor(props){
        super(props)
        this.state = {
            isLoadingView: false,
            showLoadingRequesting: false,
            showErrorRequesting: false,
            showCompletedRequesting: false,
            messageError: '',
        }
    }

    url = process.env.REACT_APP_MIFIRMA_API;
    localStorageService = new LocalStorageService()

    token = ''
    user = {}

    async componentDidMount(){
        let messageError = 'Ocurrió un error al consultar la información del Informe'
        try {
            
        } catch (error) {
            this.toggleLoadingView(false)
            this.toggleErrorRequesting(messageError, 4000, true, "/")
        }
    }

    
    toggleLoadingView = (value) => {
        this.setState({
            isLoadingView: value
        })
    }

    toggleLoadingRequesting = (value) => {
        this.setState({
            showLoadingRequesting: value,
        });
    };

    toggleErrorRequesting = (message, time, sendInbox, path) => {
        let sendTo = (path && path !== '') ? path : "/"
        this.setState({
            showErrorRequesting: true,
            messageError: message
        }, () => {
            setTimeout(() => {
                this.setState({
                    showErrorRequesting: false,
                })
                if (sendInbox) {
                    this.props.history.push(sendTo)
                }
            }, time || 4000)
        })
    }

    
    toggleCompletedRequesting = (time, sendInbox, path) => {
        let sendTo = (path && path !== '') ? path : "/"
        this.setState({
            showCompletedRequesting: true,
        }, () => {
            setTimeout(() => {
                this.setState({
                    showCompletedRequesting: false,
                })
                if (sendInbox) {
                    this.props.history.push(sendTo)
                }
            }, time || 4000)
        })
    }

    render(){
        return(
            <DigitalContractReportView 
                {...this.props}
            />
        )
    }
}

export { DigitalContractReportAction as default }